import * as yup from "yup";

export const editRefrigerantsValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  year: yup.string().required("Year is required"),
  month: yup.string().required("Month is required"),
  unit: yup.string().required("Unit is required"),
  gasType: yup.string().required("Gas type is required"),
  refrigerant: yup.string().required("Refrigerant is required"),
  amountOfFuel: yup
    .number()
    .typeError("Amount of fuel must be a valid number")
    .required("Amount of fuel is required"),
});
